// extracted by mini-css-extract-plugin
module.exports = {"curated-sets__heading":"curated-sets_curated-sets__heading__c_K9M"};